import React, { useEffect, useState } from 'react'
import { Card , Modal, Row, Col, Typography, Button, notification} from 'antd';
import { FaRegCircleCheck } from "react-icons/fa6";
import { PiContactlessPaymentLight } from "react-icons/pi";
import { MdLockOutline } from "react-icons/md";
import RetrieveModal from '../components/Modals/RetrieveModal';
import { connect } from 'react-redux';
import { setUser } from '../store/action/common/authAction';
import CryptoJS from 'crypto-js';


const { Title, Text } = Typography;

const UpgradePlan = () => {
  
  const userId = localStorage.getItem('userId')  
  const token = localStorage.getItem('accessToken')
  const userEmail = localStorage.getItem('email').replace(/"/g, '');
  const [selectedPlan, setSelectedPlan] = useState(null); 
  const [plans, setPlans] = useState([])
  const [error, setError] = useState(null)
  const [isLoading, setIsloading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const rufaryek = 'mysuper#eyra19110040267faree'


  const getEmailIdCostom = async ()=>{
    try {
        const response = await fetch(` https://euctostaging.com/lms/api/businessinitialform/showwithEmail/${userEmail}`)
        if (response.ok) {
            const result = await response.json();
            const id = result?.id; 
            if (id) {
               const encryptedId = CryptoJS.AES.encrypt(id.toString(), rufaryek).toString();
                localStorage.setItem('finalFormID', encryptedId);
               // Open a new window with the encrypted form ID in the URL
                 window.open(`https://blaccdot.co.uk/appointment?formid=${encodeURIComponent(encryptedId)}`, '_blank');
               // window.open(`http://localhost:3002/appointment?formid=${encodeURIComponent(encryptedId)}`, '_blank');
            } else {
               console.error("ID not found in response");
            }
        } else {
            alert('Some error occurred');
        }
    } catch (error) {
        alert('Some from server')
    }
  }

  // const getEmailIdCostom = async ()=>{
  //   try {
  //       const response = await fetch(` https://euctostaging.com/lms/api/businessinitialform/showwithEmail/${userEmail}`)
  //       if (response.ok) {
  //           const result = await response.json();
  //           const id = result?.id; 
  //           if (id) {
  //               localStorage.setItem('finalFormID', id);
  //                window.open(`https://blaccdot.com/appointment?formid=${id}`, '_blank');
  //           } else {
  //              console.error("ID not found in response");
  //           }
  //       } else {
  //           alert('Some error occurred');
  //       }
  //   } catch (error) {
  //       alert('Some from server')
  //   }
  // }

  const getCountryCode = (country) => {
    if (country === "United Kingdom") return 1;
    if (country === "India") return 2;
    if (country === "Canada") return 3;
    return country;
  };
  
  const country = localStorage.getItem('country');
  const domainid = localStorage.getItem('domainid')

  const fetchSubscription = async ()=> {
    setIsloading(true)
    try {
      //  const response = await fetch(`https://verse.blaccdot.com/ldsbackend/masters/subscription/all/${getCountryCode(country)}`)
       const response = await fetch(`https://verse.blaccdot.com/ldsbackend/masters/subscription/categorybased/${domainid}`)
       if(!response.ok){
        throw new Error('Failed to fetch plans')
       }
       const data = await response.json()
       const formattedPlans = data.data.subscriptionmasters.map((plan, index)=> ({
        id: plan._id,
        subscriptionmasterId:plan.subscriptionmasterId,
        title: plan.title,
        monthlyPrice: plan.monthAmount,
        currency:plan.currency,
        taxAmount: plan.taxAmount,
        description: `${plan.creditpoints}`,
        features: Object.values(plan.textcontent), 
       }))
       setPlans(formattedPlans)
    } catch (error) {
        setError(error.message);
    } finally {
        setIsloading(false)
    }
  }

   useEffect(()=>{
     fetchSubscription()
   },[])

  const showModal = (planId) => {
    const selected = plans.find((plan)=> plan.subscriptionmasterId === planId)
    setSelectedPlan(selected);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedPlan(null); 
  };



  const cardStyle = (planId) => ({
    width: '100%',
    border: `2px solid ${selectedPlan === planId ? '#7281FF' : '#e0e0e0'}`,
    transition: 'border-color 0.3s ease'
  });

  const buttonStyle = (planId) => ({
    width: '100%',
    marginTop: '10px',
    backgroundColor: selectedPlan === planId ? '#7281FF' : 'transparent',
    color: selectedPlan === planId ? 'white' : '#5f5f5f',
    border: `1px solid ${selectedPlan === planId ? '#7281FF' : '#e0e0e0'}`
  });


  const handlePaynow =  async ()=>{


    const provinceIdArray = JSON.parse(localStorage.getItem('provinceid')) || [];    
    const domainid = localStorage.getItem('domainid')
    
    try {
        const payload = {
            plantype: "Normal",
            userId: userId,
            subscriptionId: selectedPlan.subscriptionmasterId, 
            provinceId: provinceIdArray,
            country:'United Kingdom',
            longDistanceLeads: true,
            amount: selectedPlan.monthlyPrice, 
            taxAmount: selectedPlan.taxAmount,
            credit: selectedPlan.description, 
            category:domainid,
        }
        const response = await fetch(`https://verse.blaccdot.com/ldsbackend/campaign/create`,{
            method:'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${token}`
            },
            body: JSON.stringify(payload)
        }) 

        if (response.ok) {
            // notification.info({
            //     message: 'Session Expired',
            //     description: 'Your session has expired. Please log in again.',
            //     placement: 'top',
            //     duration: 0,
            //     closeIcon: null, 
            //     btn: (
            //       <Button onClick={handleLogout} type="primary">
            //         Logout
            //       </Button>
            //     ),
            //   });
            const data = await response.json()

            if (data?.data?.url) {
              window.location.href = data.data.url; 
            } else {
              notification.error({
                message: 'Payment failed',
                description: 'Some technical issues in payment try later',
                closeIcon: null, 
              });
            }
            handleCancel()
        } else {
         alert('Failed to Pay');
        }
    } catch (error) {
        alert('Failed to Pay:', error);
    }
  }

  const handleLogout = () => {
    notification.destroy(); 
    localStorage.clear(); 
    window.location.href= '/login'; 
  };

  const myWallet = localStorage.getItem('myWallet'); // Get value from localStorage
  const walletAmount = myWallet ? parseFloat(myWallet) : 0; // Convert to number


  return (
    <div>
      <Card extra={<a href="/my-profile">Back</a>} style={{ width: '100%' }}>
        <div className='container'>
            <Row>
             <Col span={12}>
                <h4 style={{ fontWeight: 700, fontFamily: "sans-serif" }}>Select Plan</h4>
                <span style={{ fontSize: 'small', color: '#5c5c5c' }}>Simple and flexible per-user pricing</span>
            </Col>
                <Col span={12}>
                {walletAmount <= 10 && (
                      <div>
                        <RetrieveModal />
                      </div>
                    )}
                </Col>
            </Row>
          
              <Modal key={selectedPlan?.subscriptionmasterId} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} width={500}
                centered
                className="payment-modal">
                    {selectedPlan ? (
                                  <div style={{ padding: '20px' }}>
                                  <Row align="middle" gutter={[8, 8]} style={{ marginBottom: '24px' }}>
                                  <Col>
                                      <MdLockOutline style={{ fontSize: '24px', color: '#7281FF' }} />
                                  </Col>
                                  <Col>
                                      <Title level={4} style={{ margin: 0, fontWeight: 700 }}>Secure Payment</Title>
                                  </Col>
                                  </Row>


                                  {/* Plan Details Section */}
                                  <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '16px', marginBottom: '24px' }}>
                                  <Title level={5} style={{ marginBottom: '16px', color: '#2d3436' }}>Order Summary</Title>
                                  
                                  <Row gutter={[16, 16]} style={{ marginBottom: '12px' }}>
                                      <Col span={12}>
                                        <Text type="secondary">Plan Name</Text>
                                        <Text strong style={{ display: 'block' }}>{selectedPlan.title}</Text>
                                      </Col>
                                      <Col span={12}>
                                        <Text type="secondary">Credits</Text>
                                        <Text strong style={{ display: 'block' }}>{selectedPlan.description}</Text>
                                      </Col>
                                  </Row>
              
                                  <Row gutter={[16, 16]}>
                                      <Col span={12}>
                                        <Text type="secondary">Subtotal</Text>
                                        <Text strong style={{ display: 'block' }}>
                                      {selectedPlan.monthlyPrice} <span style={{fontSize:'12px', marginLeft:'0px'}}>{selectedPlan.currency}</span>
                                      </Text>
                                      </Col>
                                      <Col span={12}>
                                         <Text type="secondary">Tax Amount</Text>
                                         <Text strong style={{ display: 'block' }}>
                                         {selectedPlan.taxAmount} <span style={{fontSize:'12px', marginLeft:'0px'}}>{selectedPlan.currency}</span>
                                      </Text>
                                      </Col>
                                  </Row>

                                  </div>

                                  {/* Total Amount */}
                                  <Row justify="space-between" align="middle" style={{ marginBottom: '32px', padding: '16px 0', borderTop: '1px solid #e8e8e8' }}>
                                  <Col>
                                      <Text strong style={{ fontSize: '16px' }}>Total Amount</Text>
                                  </Col>
                                  <Col>
                                      <Title level={3} style={{ margin: 0, color: '#7281FF' }}>
                                      <span style={{fontSize:'12px', marginLeft:'0px'}}>{selectedPlan.currency}</span> {(parseFloat(selectedPlan.monthlyPrice) + parseFloat(selectedPlan.taxAmount)).toFixed(2)}
                                     </Title>
                                  </Col>
                                  </Row>
                                  {/* Security Assurance */}
                                  <Row align="middle" gutter={[8, 8]} style={{ marginBottom: '24px' }}>
                                  <Col>
                                      <MdLockOutline style={{ fontSize: '16px', color: '#63BB35' }} />
                                  </Col>
                                  <Col>
                                      <Text type="secondary" style={{ fontSize: '12px' }}>
                                      Your payment is securely encrypted with SSL technology
                                      </Text>
                                  </Col>
                                  </Row>
              
                                  <Button type="primary" block  size="large" onClick={handlePaynow}
                                      style={{  height: '48px', fontSize: '16px', backgroundColor: '#7281FF',borderRadius: '8px'}}>
                                      Confirm Payment
                                  </Button>
                              </div>
                ) : (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                        <div className="loaderMain"></div>
                        </div>
                  )}
              </Modal>

            <div className='mt-4'>
                <Row gutter={16}>
                {isLoading ? (
                   <>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                    <div className="loaderMain"></div></div>
                   </>
                ) : error ? (
                    <p style={{ color: 'red' }}>Server error: {error}</p>
                ) : plans.length > 0 ? (
                    plans.map((plan) => (
                    <Col key={plan.subscriptionmasterId} span={8}> 
                        <Card style={cardStyle(plan.subscriptionmasterId)}>
                        <h6 style={{ fontFamily: 'sans-serif', fontWeight: '600', color: '#5f5f5f' }}>
                            {plan.title}
                        </h6>
                        <h2 style={{ fontFamily: 'sans-serif', fontWeight: '600', marginTop: '30px' }}>
                        {plan.monthlyPrice}<span style={{fontSize:'12px', marginLeft:'5px'}}>{plan.currency}</span>
                        </h2>
                        <p>{plan.description} Credits</p>
                        <Button size="large"
                            style={buttonStyle(plan.subscriptionmasterId)}
                            variant={selectedPlan === plan.subscriptionmasterId ? 'contained' : 'outlined'}
                            onClick={() => showModal(plan.subscriptionmasterId)}>
                            {selectedPlan === plan.subscriptionmasterId ? 'Selected' : 'Upgrade Plan'}
                        </Button>
                        <div className='mt-4'>
                            <ul style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                            {plan.features.map((feature, idx) => (
                                <li key={idx} style={{ marginBottom: '15px'}}>
                                <h6 style={{ color: '#4d4d4d', fontFamily: 'sans-serif' }}>
                                    <FaRegCircleCheck style={{ color: '#63BB35' }} className='me-2' />
                                    {feature}
                                </h6>
                                </li>
                            ))}
                            </ul>
                        </div>
                        </Card>
                    </Col>
                    ))
                ) : (
                    <p>No plans available</p>
                )}



                <Col span={8}>
                    <Card style={cardStyle('custom')}>
                    <h6 style={{ fontFamily: 'sans-serif', fontWeight: '600', color: '#5f5f5f' }}>
                        Custom plan
                    </h6>
                    <h3 style={{ fontFamily: 'sans-serif', fontWeight: '600', marginTop: '30px' }}>
                        Make Your Own
                    </h3>
                    <p>Credits as per your needs</p>
                    <Button size="large" 
                        style={buttonStyle('custom')}
                        variant={selectedPlan === 'custom' ? 'contained' : 'outlined'}
                        onClick={getEmailIdCostom}>
                        {selectedPlan === 'custom' ? 'Selected' : 'Book Meeting'}
                    </Button>
                    <div className='mt-4'>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> User roles and permissions</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Mobile accessibility</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/>  Integration with popular tools</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Standard customer support</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/>Customization options</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Mobile accessibility</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Mobile accessibility</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/>  Integration with popular tools</h6>
                        <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Standard customer support</h6>
                    </div>    
                    </Card>
                </Col>
                </Row>
            </div>
        </div>
      </Card>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
    setUser_: (data) => {
      dispatch(setUser(data));
    },
    clearLoginResponse_: () => {
        dispatch({ type: 'FETCH_LOGIN_CLEAR' });
    }
  });
  
  export default connect(
    mapDispatchToProps
  )(UpgradePlan);


// import React, { useEffect, useState } from 'react'
// import { Card , Modal, Row, Col, Typography, Button, notification} from 'antd';
// import { FaRegCircleCheck } from "react-icons/fa6";
// import { PiContactlessPaymentLight } from "react-icons/pi";
// import { MdLockOutline } from "react-icons/md";
// import RetrieveModal from '../components/Modals/RetrieveModal';
// import { connect } from 'react-redux';
// import { setUser } from '../store/action/common/authAction';

// const { Title, Text } = Typography;

// const UpgradePlan = () => {
  
//   const userId = localStorage.getItem('userId')  
//   const token = localStorage.getItem('accessToken')
//   const userEmail = localStorage.getItem('email').replace(/"/g, '');
//   const [selectedPlan, setSelectedPlan] = useState(null); 
//   const [plans, setPlans] = useState([])
//   const [error, setError] = useState(null)
//   const [isLoading, setIsloading] = useState(false)
//   const [isModalOpen, setIsModalOpen] = useState(false);



//   const getEmailIdCostom = async ()=>{
//     try {
//         const response = await fetch(` https://euctostaging.com/lms/api/businessinitialform/showwithEmail/${userEmail}`)
//         if (response.ok) {
//             const result = await response.json();
//             const id = result?.id; 
//             if (id) {
//                 localStorage.setItem('finalFormID', id);
//                  window.open(`https://blaccdot.com/appointment?formid=${id}`, '_blank');
//             } else {
//                console.error("ID not found in response");
//             }
//         } else {
//             alert('Some error occurred');
//         }
//     } catch (error) {
//         alert('Some from server')
//     }
//   }

//   const getCountryCode = (country) => {
//     if (country === "United Kingdom") return 1;
//     if (country === "India") return 2;
//     if (country === "Canada") return 3;
//     return country;
//   };
  
//   const country = localStorage.getItem('country');
//   const domainid = localStorage.getItem('domainid')

//   const fetchSubscription = async ()=> {
//     setIsloading(true)
//     try {
//       //  const response = await fetch(`https://verse.blaccdot.com/ldsbackend/masters/subscription/all/${getCountryCode(country)}`)
//        const response = await fetch(`https://verse.blaccdot.com/ldsbackend/masters/subscription/categorybased/${domainid}`)
//        if(!response.ok){
//         throw new Error('Failed to fetch plans')
//        }
//        const data = await response.json()
//        const formattedPlans = data.data.subscriptionmasters.map((plan, index)=> ({
//         id: plan._id,
//         subscriptionmasterId:plan.subscriptionmasterId,
//         title: plan.title,
//         monthlyPrice: plan.monthAmount,
//         currency:plan.currency,
//         taxAmount: plan.taxAmount,
//         description: `${plan.creditpoints}`,
//         features: Object.values(plan.textcontent), 
//        }))
//        setPlans(formattedPlans)
//     } catch (error) {
//         setError(error.message);
//     } finally {
//         setIsloading(false)
//     }
//   }

//    useEffect(()=>{
//      fetchSubscription()
//    },[])

//   const showModal = (planId) => {
//     const selected = plans.find((plan)=> plan.subscriptionmasterId === planId)
//     setSelectedPlan(selected);
//     setIsModalOpen(true);
//   };

//   const handleOk = () => {
//     setIsModalOpen(false);
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setSelectedPlan(null); 
//   };



//   const cardStyle = (planId) => ({
//     width: '100%',
//     border: `2px solid ${selectedPlan === planId ? '#7281FF' : '#e0e0e0'}`,
//     transition: 'border-color 0.3s ease'
//   });

//   const buttonStyle = (planId) => ({
//     width: '100%',
//     marginTop: '10px',
//     backgroundColor: selectedPlan === planId ? '#7281FF' : 'transparent',
//     color: selectedPlan === planId ? 'white' : '#5f5f5f',
//     border: `1px solid ${selectedPlan === planId ? '#7281FF' : '#e0e0e0'}`
//   });


//   const handlePaynow =  async ()=>{


//     const provinceIdArray = JSON.parse(localStorage.getItem('provinceid')) || [];    
//     try {
//         const payload = {
//             plantype: "Normal",
//             userId: userId,
//             subscriptionId: selectedPlan.subscriptionmasterId, 
//             provinceId: provinceIdArray,
//             country:'United Kingdom',
//             longDistanceLeads: true,
//             amount: selectedPlan.monthlyPrice, 
//             taxAmount: selectedPlan.taxAmount,
//             credit: selectedPlan.description, 
//         }
//         const response = await fetch(`https://verse.blaccdot.com/ldsbackend/campaign/create`,{
//             method:'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Authorization': `${token}`
//             },
//             body: JSON.stringify(payload)
//         }) 

//         if (response.ok) {
//             // notification.info({
//             //     message: 'Session Expired',
//             //     description: 'Your session has expired. Please log in again.',
//             //     placement: 'top',
//             //     duration: 0,
//             //     closeIcon: null, 
//             //     btn: (
//             //       <Button onClick={handleLogout} type="primary">
//             //         Logout
//             //       </Button>
//             //     ),
//             //   });
//             const data = await response.json()

//             if (data?.data?.url) {
//               window.location.href = data.data.url; 
//             } else {
//               notification.error({
//                 message: 'Payment failed',
//                 description: 'Some technical issues in payment try later',
//                 closeIcon: null, 
//               });
//             }
//             handleCancel()
//         } else {
//          alert('Failed to Pay');
//         }
//     } catch (error) {
//         alert('Failed to Pay:', error);
//     }
//   }

//   const handleLogout = () => {
//     notification.destroy(); 
//     localStorage.clear(); 
//     window.location.href= '/login'; 
//   };

//   const myWallet = localStorage.getItem('myWallet'); // Get value from localStorage
//   const walletAmount = myWallet ? parseFloat(myWallet) : 0; // Convert to number


//   return (
//     <div>
//       <Card extra={<a href="/my-profile">Back</a>} style={{ width: '100%' }}>
//         <div className='container'>
//             <Row>
//              <Col span={12}>
//                 <h4 style={{ fontWeight: 700, fontFamily: "sans-serif" }}>Select Plan</h4>
//                 <span style={{ fontSize: 'small', color: '#5c5c5c' }}>Simple and flexible per-user pricing</span>
//             </Col>
//                 <Col span={12}>
//                 {walletAmount <= 10 && (
//                       <div>
//                         <RetrieveModal />
//                       </div>
//                     )}
//                 </Col>
//             </Row>
          
//               <Modal key={selectedPlan?.subscriptionmasterId} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} width={500}
//                 centered
//                 className="payment-modal">
//                     {selectedPlan ? (
//                                   <div style={{ padding: '20px' }}>
//                                   <Row align="middle" gutter={[8, 8]} style={{ marginBottom: '24px' }}>
//                                   <Col>
//                                       <MdLockOutline style={{ fontSize: '24px', color: '#7281FF' }} />
//                                   </Col>
//                                   <Col>
//                                       <Title level={4} style={{ margin: 0, fontWeight: 700 }}>Secure Payment</Title>
//                                   </Col>
//                                   </Row>


//                                   {/* Plan Details Section */}
//                                   <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '16px', marginBottom: '24px' }}>
//                                   <Title level={5} style={{ marginBottom: '16px', color: '#2d3436' }}>Order Summary</Title>
                                  
//                                   <Row gutter={[16, 16]} style={{ marginBottom: '12px' }}>
//                                       <Col span={12}>
//                                         <Text type="secondary">Plan Name</Text>
//                                         <Text strong style={{ display: 'block' }}>{selectedPlan.title}</Text>
//                                       </Col>
//                                       <Col span={12}>
//                                         <Text type="secondary">Credits</Text>
//                                         <Text strong style={{ display: 'block' }}>{selectedPlan.description}</Text>
//                                       </Col>
//                                   </Row>
              
//                                   <Row gutter={[16, 16]}>
//                                       <Col span={12}>
//                                         <Text type="secondary">Subtotal</Text>
//                                         <Text strong style={{ display: 'block' }}>
//                                       {selectedPlan.monthlyPrice} <span style={{fontSize:'12px', marginLeft:'0px'}}>{selectedPlan.currency}</span>
//                                       </Text>
//                                       </Col>
//                                       <Col span={12}>
//                                          <Text type="secondary">Tax Amount</Text>
//                                          <Text strong style={{ display: 'block' }}>
//                                          {selectedPlan.taxAmount} <span style={{fontSize:'12px', marginLeft:'0px'}}>{selectedPlan.currency}</span>
//                                       </Text>
//                                       </Col>
//                                   </Row>

//                                   </div>

//                                   {/* Total Amount */}
//                                   <Row justify="space-between" align="middle" style={{ marginBottom: '32px', padding: '16px 0', borderTop: '1px solid #e8e8e8' }}>
//                                   <Col>
//                                       <Text strong style={{ fontSize: '16px' }}>Total Amount</Text>
//                                   </Col>
//                                   <Col>
//                                       <Title level={3} style={{ margin: 0, color: '#7281FF' }}>
//                                       <span style={{fontSize:'12px', marginLeft:'0px'}}>{selectedPlan.currency}</span> {(parseFloat(selectedPlan.monthlyPrice) + parseFloat(selectedPlan.taxAmount)).toFixed(2)}
//                                      </Title>
//                                   </Col>
//                                   </Row>
//                                   {/* Security Assurance */}
//                                   <Row align="middle" gutter={[8, 8]} style={{ marginBottom: '24px' }}>
//                                   <Col>
//                                       <MdLockOutline style={{ fontSize: '16px', color: '#63BB35' }} />
//                                   </Col>
//                                   <Col>
//                                       <Text type="secondary" style={{ fontSize: '12px' }}>
//                                       Your payment is securely encrypted with SSL technology
//                                       </Text>
//                                   </Col>
//                                   </Row>
              
//                                   <Button type="primary" block  size="large" onClick={handlePaynow}
//                                       style={{  height: '48px', fontSize: '16px', backgroundColor: '#7281FF',borderRadius: '8px'}}>
//                                       Confirm Payment
//                                   </Button>
//                               </div>
//                 ) : (
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//                         <div className="loaderMain"></div>
//                         </div>
//                   )}
//               </Modal>

//             <div className='mt-4'>
//                 <Row gutter={16}>
//                 {isLoading ? (
//                    <>
//                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//                     <div className="loaderMain"></div></div>
//                    </>
//                 ) : error ? (
//                     <p style={{ color: 'red' }}>Server error: {error}</p>
//                 ) : plans.length > 0 ? (
//                     plans.map((plan) => (
//                     <Col key={plan.subscriptionmasterId} span={8}> 
//                         <Card style={cardStyle(plan.subscriptionmasterId)}>
//                         <h6 style={{ fontFamily: 'sans-serif', fontWeight: '600', color: '#5f5f5f' }}>
//                             {plan.title}
//                         </h6>
//                         <h2 style={{ fontFamily: 'sans-serif', fontWeight: '600', marginTop: '30px' }}>
//                         {plan.monthlyPrice}<span style={{fontSize:'12px', marginLeft:'5px'}}>{plan.currency}</span>
//                         </h2>
//                         <p>{plan.description} Credits</p>
//                         <Button size="large"
//                             style={buttonStyle(plan.subscriptionmasterId)}
//                             variant={selectedPlan === plan.subscriptionmasterId ? 'contained' : 'outlined'}
//                             onClick={() => showModal(plan.subscriptionmasterId)}>
//                             {selectedPlan === plan.subscriptionmasterId ? 'Selected' : 'Upgrade Plan'}
//                         </Button>
//                         <div className='mt-4'>
//                             <ul style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
//                             {plan.features.map((feature, idx) => (
//                                 <li key={idx} style={{ marginBottom: '15px'}}>
//                                 <h6 style={{ color: '#4d4d4d', fontFamily: 'sans-serif' }}>
//                                     <FaRegCircleCheck style={{ color: '#63BB35' }} className='me-2' />
//                                     {feature}
//                                 </h6>
//                                 </li>
//                             ))}
//                             </ul>
//                         </div>
//                         </Card>
//                     </Col>
//                     ))
//                 ) : (
//                     <p>No plans available</p>
//                 )}



//                 <Col span={8}>
//                     <Card style={cardStyle('custom')}>
//                     <h6 style={{ fontFamily: 'sans-serif', fontWeight: '600', color: '#5f5f5f' }}>
//                         Custom plan
//                     </h6>
//                     <h3 style={{ fontFamily: 'sans-serif', fontWeight: '600', marginTop: '30px' }}>
//                         Make Your Own
//                     </h3>
//                     <p>Credits as per your needs</p>
//                     <Button size="large" 
//                         style={buttonStyle('custom')}
//                         variant={selectedPlan === 'custom' ? 'contained' : 'outlined'}
//                         onClick={getEmailIdCostom}>
//                         {selectedPlan === 'custom' ? 'Selected' : 'Book Meeting'}
//                     </Button>
//                     <div className='mt-4'>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> User roles and permissions</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Mobile accessibility</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/>  Integration with popular tools</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Standard customer support</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/>Customization options</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Mobile accessibility</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Mobile accessibility</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/>  Integration with popular tools</h6>
//                         <h6 style={{color: '#4d4d4d',fontFamily: 'sans-serif', marginBottom: '15px'}}><FaRegCircleCheck style={{color:'#63BB35'}} className='me-2'/> Standard customer support</h6>
//                     </div>    
//                     </Card>
//                 </Col>
//                 </Row>
//             </div>
//         </div>
//       </Card>
//     </div>
//   )
// }

// const mapDispatchToProps = dispatch => ({
//     setUser_: (data) => {
//       dispatch(setUser(data));
//     },
//     clearLoginResponse_: () => {
//         dispatch({ type: 'FETCH_LOGIN_CLEAR' });
//     }
//   });
  
//   export default connect(
//     mapDispatchToProps
//   )(UpgradePlan);


